<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="title"
    :visible="showDownload"
    @close="dialogClose"
    width="90%"
  >
    <template v-if="showDownload">
      <cc-table
        :loadData="true"
        :config="tableLog"
        :params="paramslog"
        :refeshParams="refeshParams"
      ></cc-table>
    </template>
  </el-dialog>
</template>
<script>
export default {
  props: {
    showDownload: Boolean,
    title: {
      type: String,
      default: "上传记录",
    },
    api: {
      type: String,
      default: "admin/fsb/common/export/log/query",
    },
  },
  data() {
    return {
      tableLog: {
        api: this.api,
        showPager: true,
        columns: [
          {
            prop: "createTime",
            lable: "上传时间",
            minWidth: 150,
          },

          {
            prop: "customFileName",
            lable: "标题",
            minWidth: 100,
          },
          {
            prop: "address",
            lable: "错误信息文件地址",
            minWidth: 500,
            render:row=>{
              return   process.env.VUE_APP_home+row.address
            }
          },
          {
            prop: "adminName",
            lable: "操作者",
            minWidth: 100,
          },
        ],
        buttons: [
          {
            name: "下载错误信息文件",
            click: (row) => {
              window.open(row.address, "下载");
            },
            check: (row) => {
              if (row.address) {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            name: "下载源文件",
            click: (row) => {
              // console.log(row.filePath)
              window.open(row.filePath, "下载");
            },
          },
          {},
          {},
        ],
      },
      paramslog: {},
      refeshParams: -1,
    };
  },
  methods: {
    dialogClose() {
      this.$emit("update:showDownload", false);
    },
  },
};
</script>